<template>
  <div>
    <v-progress-circular v-show="loading" :size="70" :width="7" color="purple" indeterminate></v-progress-circular>
    <template v-if="!loggedIn">
      <h1>Please log in first</h1>
    </template>

    <template v-if="loggedIn && !Management">
      <h1>Loading management API</h1>
    </template>

    <template v-if="loggedIn && Management">
      <h1>Webproperties explorer</h1>

      <div v-if="webproperties" id="webproperties">
        <v-text-field v-model="search" append-icon="search" placeholder="Filter results"></v-text-field>
        <v-data-table
          :rows-per-page-items="rowsPerPage"
          :headers="headers.properties"
          :items="webproperties"
          :search="search"
        >
          <template slot="items" slot-scope="props">
            <router-link :to="`/accounts/${accountId}/properties/${props.item.id}`" tag="tr">
              <td>{{ props.item.name }}</td>
              <td class="text-xs-left">{{ props.item.id }}</td>
              <td class="text-xs-left">{{ props.item.kind }}</td>
              <td class="text-xs-left">{{ props.item.selfLink }}</td>
            </router-link>
          </template>
        </v-data-table>

        <!-- Action buttons -->
        <v-btn
          id="fetchProperties"
          v-if="!webproperties.length"
          @click="fetchProperties"
        >Load properties</v-btn>

        <v-btn
          id="downloadAccountOverview"
          download
          :href="this.accountReportLink"
          @click="getAccountReport"
        >Download the Account Report</v-btn>

        <!-- <v-btn
          id="downloadAccountOverview"
          :href="this.getAccountOverviewLink"
          download
        >Download account overview</v-btn>-->
      </div>
    </template>
  </div>
</template>

<script>
import store from "@/store.js";

console.log(process.env.NODE_ENV);
export default {
  name: "Webproperties-Overview",
  props: ["accountId"],
  data() {
    return {
      loading: false,
      webproperties: [],
      views: [],
      search: "",
      rowsPerPage: [
        15,
        25,
        50,
        { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
      ],
      headers: {
        properties: [
          {
            text: "Property Name",
            align: "left",
            value: "name"
          },
          { text: "Property ID", value: "id" },
          { text: "Kind", value: "kind" },
          { text: "Link", value: "link" }
        ]
      }
    };
  },
  computed: {
    Management() {
      return this.$store.state.google.management;
    },
    loggedIn() {
      return this.$store.state.auth.signedIn;
    },
    authParams() {
      return this.$store.state.auth.params;
    },
    accountReportLink() {
      if (process.env.NODE_ENV === "development") {
        return `http://localhost:3000/accounts/${this.accountId}/report${
          this.authParams
        }`;
      } else {
        return `/api/accounts/${this.accountId}/report${this.authParams}`;
      }
    },
    getAccountOverviewLink() {
      if (process.env.NODE_ENV === "development") {
        return `http://localhost:3000/accounts/${this.accountId}/overview${
          this.authParams
        }`;
      } else {
        return `/api/accounts/${this.accountId}/overview${this.authParams}`;
      }
    }
  },
  methods: {
    getAccountReport() {
      let notification = {
        type: "info",
        message: "Account report generating on server..."
      };

      this.$store.dispatch("addNotification", notification);
    },
    fetchProperties() {
      this.Management.webproperties
        .list({ accountId: this.accountId })
        .then(res => {
          if (res.status === 200) {
            this.webproperties = res.result.items;
          }
        })
        .catch(err => console.error(err));
    }
  },
  mounted() {
    this.$store.dispatch("setNavigation", {
      account: this.accountId
    });
    if (this.Management && !this.webproperties.length) {
      this.fetchProperties();
    }
  },
  watch: {
    Management(newV, oldV) {
      if (!oldV && newV && this.webproperties.length == 0) {
        this.fetchProperties();
      }
    }
  }
};
</script>


<style scoped>
tr,
td {
  cursor: pointer;
}
</style>